<template>
    <div class="total-order-prices">
        <PricesWithCommission
            :order-prices="priceInSystemCurrency"
            :title="title"
            :vat-calculated-amount-by-each-service-brutto="vatCalculatedAmountByEachServiceBrutto"
            :is-show-net-value="isShowNetValue"
            :is-show-v-a-t-commission="isShowVATCommission"
        >
            <v-tooltip v-if="showConvertPrices" v-model="show" location="top" width="260">
                <template v-slot:activator="{props}">
                    <v-btn
                        v-bind="props"
                        size="small"
                        icon="mdi-cash-multiple"
                        variant="text"
                        density="compact"
                        color="grey"
                        class="mx-2 mb-2"
                        data-cy="show-currency-multiple"
                        @click="show = !show"
                    />
                </template>
                <PricesWithCommission
                    :order-prices="orderPrices"
                    :vat-calculated-amount-by-each-service-brutto="vatCalculatedAmountByEachServiceBrutto"
                    :is-show-net-value="isShowNetValue"
                    :is-show-v-a-t-commission="isShowVATCommission"
                />
            </v-tooltip>
        </PricesWithCommission>
        <div class="commission-block align-center justify-space-between flex-wrap gc-4 gr-2">
            <slot />
            <payment-status-label class="ml-auto" :status="paymentStatus" :card-guarantee="serviceCardGuarantee" />
        </div>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import PaymentStatusLabel from '~src/components/account/snippets/paymentStatusLabel.src'
    import PricesWithCommission from '~/components/account/snippets/PricesWithCommission.vue'

    @Component({
        components: {PricesWithCommission, PaymentStatusLabel},
    })
    export class TotalOrderPrices extends Vue {
        @Prop({required: true}) title
        @Prop({required: true}) orderPrices
        @Prop({required: true}) paymentStatus
        @Prop({required: true}) serviceCardGuarantee
        @Prop() services
        @Prop() vatCalculatedAmountByEachServiceBrutto

        show = false

        get isShowNetValue() {
            return false
        }

        get isShowVATCommission() {
            return false
        }

        get showConvertPrices() {
            return persistentStore.showConvertPrices && this.orderPrices?.length > 1
        }

        get priceInSystemCurrency() {
            if (this.showConvertPrices) {
                let prices = []
                const totalPrice = calcTotalPrice(this.orderPrices)
                const totalPriceInSystemCurrency = convertPrice(totalPrice, authStore.systemCurrency)
                prices.push(totalPriceInSystemCurrency)
                return prices
            }
            return this.orderPrices
        }
    }

    export default TotalOrderPrices
</script>
<style lang="scss" scoped>
    @use 'vuetify/settings';
    @use 'sass:map';

    .v-tooltip :deep(.v-overlay__content) {
        background-color: white;
        color: black;
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
    }
</style>
